import { render, staticRenderFns } from "./PwdUpdate.vue?vue&type=template&id=136ddcaf&"
import script from "./PwdUpdate.vue?vue&type=script&lang=js&"
export * from "./PwdUpdate.vue?vue&type=script&lang=js&"
import style0 from "./PwdUpdate.vue?vue&type=style&index=0&id=136ddcaf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports